<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icons / Play Next">
      <g id="Vector">
        <path d="M4.83704 14.9562C4.17039 15.3451 3.33317 14.8642 3.33317 14.0925L3.33317 5.90787C3.33317 5.13608 4.17039 4.6552 4.83704 5.04409L11.8524 9.13638C12.5139 9.52226 12.5139 10.4781 11.8524 10.8639L4.83704 14.9562ZM16.6665 15.8335L16.6665 4.16683L16.6665 15.8335Z" fill="white" style="fill:white;fill:white;fill-opacity:1;" />
        <path d="M16.6665 15.8335L16.6665 4.16683M11.8524 9.13638L4.83704 5.04409C4.17039 4.6552 3.33317 5.13608 3.33317 5.90787L3.33317 14.0925C3.33317 14.8642 4.17039 15.3451 4.83704 14.9562L11.8524 10.8639C12.5139 10.4781 12.5139 9.52226 11.8524 9.13638Z" stroke="white" style="stroke:white;stroke:white;stroke-opacity:1;" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </g>
    </g>
  </svg>
</template>
